// extracted by mini-css-extract-plugin
export default {"smaller":"PageExport_smaller__0m9vU"};